module.exports = __webpack_public_path__ + "img/party1.6c64e1d3.png";